'use client';

import { useTranslations } from 'next-intl';

import { AlertBanner } from '@/components/shared/AlertBanner';
import { cn } from '@/lib/utils/cn';
import { useGlobalData } from '@/providers/GlobalDataProvider';

interface I_LockedAccountBannerProps {
  className?: string;
}

export const LockedAccountBanner = ({
  className
}: I_LockedAccountBannerProps) => {
  const t = useTranslations();
  const user = useGlobalData('user');

  if (!user?.suspended) return null;

  return (
    <AlertBanner
      text={t('profile.userInfo.accountLocked')}
      showButton={false}
      variant="destructive"
      className={cn(
        'justify-center items-center text-left md:text-center',
        className
      )}
    />
  );
};
